import { graphql, HttpResponse } from 'msw'
import { type EnrollmentMultiDisclosuresData, type EnrollmentMultiDisclosuresSubmitOutput } from '../../../../models'

export const getEnrollmentMultiDisclosuresDataMock: EnrollmentMultiDisclosuresData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/multi/disclosures',
}

export const submitEnrollmentMultiDisclosuresDataMock: EnrollmentMultiDisclosuresSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/multi/setting-up',
}

export const mockGetEnrollmentMultiDisclosuresData = graphql.mutation('getEnrollmentMultiDisclosuresData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentMultiDisclosuresDataMock } })
})

export const mockSubmitEnrollmentMultiDisclosuresData = graphql.mutation('submitEnrollmentMultiDisclosuresData', () => {
  return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentMultiDisclosuresDataMock } })
})

export const mockEnrollmentMultiDisclosures = [
  mockGetEnrollmentMultiDisclosuresData,
  mockSubmitEnrollmentMultiDisclosuresData,
]
